import { Row, Col, Card, message, } from 'antd';
import { useState } from 'react';
import DataTable from 'react-data-table-component';
import { useHistory } from 'react-router-dom';
import LoaderComponent from '../components/Loader';
import NoDataFoundComponent from '../components/NoDataFound';
import UserSearchComponent from '../components/UserSearchForm';
import { getQueryParams } from '../helpers/genericHelper';
import API from '../services/API';

const VALID_PHONE_CHARACTERS = /^[\d\s()+.-]*$/;
const DEFAULT_ROWS_PER_PAGE = 10;
const ROWS_PER_PAGE_OPTIONS = [DEFAULT_ROWS_PER_PAGE, 15, 20, 25, 30];

// The results page lives in the URL like the search fields do, so coming back from an
// account returns to it, and a new search (which rewrites the URL) starts from page 1
const getResultsPagingFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const page = Number(searchParams.get('page'));
  const rowsPerPage = Number(searchParams.get('rowsPerPage'));

  return {
    page: Number.isInteger(page) && page > 0 ? page : 1,
    rowsPerPage: ROWS_PER_PAGE_OPTIONS.includes(rowsPerPage) ? rowsPerPage : DEFAULT_ROWS_PER_PAGE,
  };
};

const setResultsPagingInUrl = (name, value) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(name, value);
  window.history.replaceState(window.history.state, '', `${window.location.pathname}?${searchParams.toString()}`);
};

function Users() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const rowClickHandler = (data) => {
    history.push(`/user/${data.userId}`)
  }

  function formatPhoneNumber(input) {
    // Remove any non-digit characters
    // and a leading US country code, so +1 and 1 prefixed numbers match too
    const cleaned = (input?.trim()??'').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  
    // Check if the cleaned number has 10 digits
    if (cleaned.length === 10) {
      console.log("line 27");
      // Format the number as +1 followed by the 10 digits
      return `+1${cleaned}`;
    } else {
      // If the input does not have exactly 10 digits, return null
      
      return null;
    }
  }

  const searchUserData = async (rawPhone, email, firstName, lastName, userId, bloomAccountId, tradelineNo, checkoutId, dateOfBirth) => {
    // setLoading(true);
    try {

      if (rawPhone && !VALID_PHONE_CHARACTERS.test(rawPhone)) {
        message.error('Phone number can only contain digits and punctuation');
        setData([]);
        return;
      }

      // BE is expecting +1{10 - digits}
      let phone = formatPhoneNumber(rawPhone);
      if (rawPhone?.trim() && !phone) {
        message.error('Phone number must have 10 digits (or 11 with a leading 1)');
        setData([]);
        return;
      }
      const params = { phone, email, firstName, lastName, userId, bloomAccountId, tradelineNo, checkoutId, dateOfBirth };
      const filteredParams = Object.keys(params).reduce((acc, key) => {
        const value = params[key]?.trim(); // Pasted values often have stray spaces
        if (value) { // Skip null, undefined and blank values
          acc[key] = encodeURIComponent(value);
        }
        return acc;
      }, {});

      if (Object.keys(filteredParams).length === 0) {
        setData([]);
      } else {
        setLoading(true);
        const queryParams = getQueryParams(filteredParams);
        let response = await API.searchUsers(queryParams);
        setData(response?.users || []);
      }
    } catch (e) {
      message.error('Unable to fetch the list');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Search Users">
              <UserSearchComponent searchUserData={searchUserData} />
              <div className="table-responsive">
                {/* Swapping in the loader rebuilds the table on every search, which is what
                    makes it start from the page saved in the URL. Keep the rebuild. */}
                {loading ? <LoaderComponent />
                  : <DataTable
                    columns={columns}
                    data={data} pagination
                    paginationDefaultPage={getResultsPagingFromUrl().page}
                    paginationPerPage={getResultsPagingFromUrl().rowsPerPage}
                    paginationRowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                    onChangePage={(page) => setResultsPagingInUrl('page', page)}
                    onChangeRowsPerPage={(rowsPerPage, page) => {
                      // The table moves to a different page when the page size changes
                      setResultsPagingInUrl('rowsPerPage', rowsPerPage);
                      setResultsPagingInUrl('page', page);
                    }}
                    onRowClicked={rowClickHandler}
                    noDataComponent={<NoDataFoundComponent />}
                  />}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Users;


const columns = [
  {
    name: 'First Name',
    selector: (row) => row.firstName,
    sortable: true,
  },
  {
    name: 'Last Name',
    selector: (row) => row.lastName,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.email,
    sortable: true,
  },
  {
    name: 'User Id',
    selector: (row) => row.userId,
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.status,
  },
  {
    name: 'Date Of Birth',
    selector: (row) => {
      if (row.dob === null || row.dob === 'null')
        return '';
      else
        return row.dob
    }
  },
];
